<div class="bracket" *ngIf="bracket">
  <div class="bracket-round" *ngFor="let round of rounds; let i = index">
    <div class="round-label">{{ roundLabel(i + 1) }}</div>
    <div class="round-matches">
      <div
        class="match-card"
        *ngFor="let m of round"
        data-testid="match-card"
        [class.playable]="organizer && isPlayable(m)"
        [class.decided]="m.winner_team_id"
        (click)="onMatchClick(m)">
        <div class="team-row" [class.winner]="m.winner_team_id && m.winner_team_id === m.team_a_id">
          <span class="team-name">{{ teamLabel(m.team_a_name, m.team_a_id) }}</span>
        </div>
        <div class="team-row" [class.winner]="m.winner_team_id && m.winner_team_id === m.team_b_id">
          <span class="team-name">{{ teamLabel(m.team_b_name, m.team_b_id) }}</span>
        </div>
        <div class="walkover-tag" *ngIf="m.is_walkover">walkover</div>
      </div>
    </div>
  </div>
</div>
